<template>
  <Section
    @back="$emit('back')"
    title="対象クラスター・配信対象エリア設定"
    margin
    tip-message="対象クラスター設定に戻る"
  >
    <template>
      <v-subheader>クラスター</v-subheader>
      <v-layout
        v-for="(cluster, index) in menuSetting.clusterIdAndNames"
        :key="`cluster${index}`"
        pl-4
      >
        <v-flex xs9>{{ cluster.name }}</v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>対象地域</v-subheader>
      <v-layout
        v-for="(prefecture, index) in menuSetting.prefectureIdAndNames"
        :key="`prefecture${index}`"
        pl-4
      >
        <v-flex xs9>{{ prefecture.name }}</v-flex>
      </v-layout>
    </template>
    <template v-if="menuSetting.memo != ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>{{ menuSetting.orderDescription.memo }}</v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
export default {
  name: 'CampaignModalPageConfirmGeoGenomeTarget',
  components: { Section },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
  },
}
</script>
